<template>
  <div class="container">
    <h4 class="cardD">Datos generales de la Nueva Sociedad</h4>

    <div class="row">
      <div class="col-6">
        <ValidationProvider
          name="tipo_societario"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'El tipo de societario es obligatorio',
          }"
        >
          <label for="">Tipo de societario</label>
          <select class="custom-select" v-model="constitutiva.tipo_societario" :disabled="disabledDatosGenerales">
            <option value="SA">SA</option>
            <option value="S de RL">S de RL</option>
            <option value="SAPI">SAPI</option>
          </select>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <ValidationProvider
          name="denominaciones_sociales"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'La denominación social es obligatoria',
          }"
        >
          <base-input
            :disabled="disabledDatosGenerales"
            type="text"
            label="Denominación social"
            placeholder="Opción 1"
            v-model="constitutiva.denominaciones_sociales_1"
          ></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider
          name="denominaciones_sociales"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'La denominación social es obligatoria',
          }"
        >
          <base-input
            :disabled="disabledDatosGenerales"
            type="text"
            label=""
            placeholder="Opción 2"
            v-model="constitutiva.denominaciones_sociales_2"
          ></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider
          name="denominaciones_sociales"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'La denominación social es obligatoria',
          }"
        >
          <base-input
            :disabled="disabledDatosGenerales"
            type="text"
            label=""
            placeholder="Opción 3"
            v-model="constitutiva.denominaciones_sociales_3"
          ></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-6">
        <label for="input-autoriza-cd-denominacion">
          En caso de ser rechazada, autoriza a Correduría Digital proponer alguna
        </label>
        <b-form-checkbox
          id="input-autoriza-cd-denominacion"
          v-model="constitutiva.autoriza_cd_denominacion"
          :disabled="disabledDatosGenerales"
        ></b-form-checkbox>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <ValidationProvider
          name="objeto_social"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'El objeto social es obligatorio',
          }"
        >
          <label for="">Objeto social</label>
          <select class="custom-select" v-model="constitutiva.objeto_social" :disabled="disabledDatosGenerales">
            <option v-for="option in optionsObjetoSocial" :key="option.value">
              {{ option.text }}
            </option>
          </select>

          <base-input
            :disabled="disabledDatosGenerales"
            class="mt-2"
            type="text"
            label=""
            placeholder="Objeto Social"
            v-model="constitutiva.objeto_social_otro"
            v-if="constitutiva.objeto_social === 'Otro'"
          ></base-input>

          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <ValidationProvider
          name="objeto_actividad"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'El objeto y actividad es obligatorio',
          }"
        >
          <label>Cuéntanos qué actividades desarrollará la empresa</label>
          <b-form-textarea
            :disabled="disabledDatosGenerales"
            type="text"
            placeholder="Actividades que desarrollará la empresa"
            v-model="constitutiva.objeto_actividad"
          ></b-form-textarea>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="mt-4">
      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button type="submit" class="btn-fill orange-btn" :disabled="disabledDatosGenerales">Guardar</b-button>
          <b-button variant="success" class="btn-fill" :disabled="disabledDatosGenerales" @click="validar">Validar</b-button>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>
export default {
  name: "TabDatosGenerales",

  props: {
    constitutiva: { type: Object },
    optionsObjetoSocial: { type: Array },
  },

  data() {
    return {};
  },

  computed: {
    disabledDatosGenerales() {
      const formulario = this.constitutiva.formularios.find((f) => f.formulario === "DatosGenerales");

      return formulario?.valido == 1;
    },
  },

  methods: {
    validar() {
      this.$emit("validaForm", "DatosGenerales");
    },
  },
};
</script>
